<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs v-show="filter_cell">
        <!-- 组级策略 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.userLevel") }}</span>
          <div class="main">
            <p>
              <el-button
                @click="tan()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.userLevel1") }}</el-button
              >
              <el-alert
                :title="this.load_hind1"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                >
                </el-table-column>

                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template slot-scope="scope">
                    <!-- 删除-->

                    <el-button
                      @click="handleClick_group(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >

                    <!--    组规则设置-->

                    <el-button
                      @click="bianji2(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("logs.group1_e2") }}</el-button
                    >
                    <!--    组收信个性化设置-->

                    <el-button
                      @click="bianji3(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("logs.group1_e3") }}</el-button
                    >
                    <!--     组发信个性化设置  -->

                    <el-button
                      @click="bianji4(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("logs.group1_e4") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_group" v-drag="{ handle: '.pop_up_text_cert_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_cert_domain"><span class="span_pad"></span> {{$t('logs.userLevel1')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.userLevel2") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="email_name" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_group" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="cancel_group()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_group"></div>
          </div>
        </el-tab-pane>
        <!-- 过滤规则 -->
        <el-tab-pane label="过滤规则">
          <span slot="label">{{ $t("logs.group2") }}</span>
          <div class="main">
            <p>
              <el-alert
                :title="this.load_hind2"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="50"
                >
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOWTYPE"
                  :label="$t('table1.type')"
                  width="100"
                >
                </el-table-column>
                <el-table-column prop="HEADER_KEY" :label="$t('table1.header')">
                </el-table-column>
                <el-table-column
                  prop="SHOWDIRECT"
                  :label="$t('logs.firewall2_a2')"
                >
                </el-table-column>
                <el-table-column prop="SCORE" :label="$t('table1.score')">
                </el-table-column>
                <el-table-column prop="EMAIL_REGEX" :label="$t('table1.rule')">
                </el-table-column>

                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template slot-scope="scope">
                    <!-- 删除-->

                    <el-button
                      @click="handleClick_regex(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">保存</el-button>
                <el-button type="primary" @click="tanOff()">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- IP白名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.ipw") }}</span>
          <div class="main">
            <p>
              <el-alert
                :title="this.load_hind3"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                >
                </el-table-column>
                <el-table-column prop="IP" :label="$t('logs.network1_a5')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template slot-scope="scope">
                    <!-- 删除-->

                    <el-button
                      @click="handleClick_white(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">保存</el-button>
                <el-button type="primary" @click="tanOff()">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- IP黑名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.ipb") }}</span>
          <div class="main">
            <p>
              <el-alert
                :title="this.load_hind4"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList3"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                >
                </el-table-column>
                <el-table-column prop="IP" :label="$t('logs.network1_a5')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template slot-scope="scope">
                    <!-- 删除-->

                    <el-button
                      @click="handleClick_black(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template></el-table-column
                >
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">保存</el-button>
                <el-button type="primary" @click="tanOff()">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- From白名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.fromw") }}</span>
          <div class="main">
            <p>
               <!-- 导入发件人白名单 -->

               <el-button
               style="margin-right:0px"
                @click="tan_white()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("confirm.search") }}</el-button
              >
            <!-- 导出发件人白名单 -->

                        <el-button @click="daochu_wrap_w()" :disabled="$root.jurisdiction.only_query==0" style="margin-right:8px">{{ $t("table1.expws") }}</el-button>
              <el-select
                style="width:12%"
                v-model="salt_from_bl"
                placeholder="请选择"
                class="sele1"
                @change="change1"
                v-if="this.salt_from_bl_show == 1"
              >
                <el-option
                  v-for="item in salt_from_bl_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-alert
                :title="this.load_hind5"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
     
          <!-- 导入发件人查询 -->

           <div class="pop-up" v-show="tanchu_from_w"  v-drag="{ handle: '.pop_up_text_relay_domain' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_relay_domain">
                <span style="padding:0 14px"></span>{{ $t("confirm.search") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                 
                  <div class="find_from_w">
                   <span>{{ $t("logs.userLevel2") }}: </span> <el-input v-model="email_name_from_w" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  
                  <div class="find_from_w">
                  <span> {{ $t("logs.notify7") }}: </span> <el-input v-model=" dnoremail_from_w" placeholder=""></el-input>
                  </div>
                </div>
                  <div class="find1">
                 
                  <div class="find_from_w">
                   <span>{{ $t("logs.addt") }}:</span>   <el-date-picker
                v-model="creat_eamil"
                type="datetimerange"
                :range-separator="$t('wasteInsulate1.zhi')"
                :start-placeholder="$t('table.sdata')"
                :end-placeholder="$t('table.enddata')"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_from_w">{{
                  $t("confirm.search")
                }}</el-button>
                <el-button type="danger" @click="cancel_from_w()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_from_w"></div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable4"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList4"
                v-loading="loading"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                >
                </el-table-column>
                <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')">
                </el-table-column>
                 <el-table-column prop="CREATETIME" :label="$t('logs.addt')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template slot-scope="scope">
                    <!-- 删除-->

                    <el-button
                      @click="handleClick_from(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template></el-table-column
                >
              </el-table>
                <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums"
              ></el-pagination>
            </div>
            </div>
            
          </div>
        </el-tab-pane>
        <!-- From黑名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.fromb") }}</span>
          <div class="main">
            <p>
               <el-button
               style="margin-right:10px"
                @click="tan_white()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("confirm.search") }}</el-button
              >
                <!-- 导出发件人黑名单 -->

                        <el-button @click="daochu_wrap_b()" :disabled="$root.jurisdiction.only_query==0" style="margin-right:8px">{{ $t("table1.expws") }}</el-button>
                <el-select
                style="width:12%"
                v-model="salt_from_bl"
                placeholder="请选择"
                class="sele1"
                @change="change1"
                v-if="this.salt_from_bl_show == 1"
              >
                <el-option
                  v-for="item in salt_from_bl_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-alert
                :title="this.load_hind6"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
            <div class="pop-up" v-show="tanchu_from_w"  v-drag="{ handle: '.pop_up_text_ROUTE_ADDRESS' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_ROUTE_ADDRESS">
                <span style="padding:0 14px"></span>{{ $t("confirm.search") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                 
                  <div class="find_from_w">
                   <span>{{ $t("logs.userLevel2") }}: </span> <el-input v-model="email_name_from_b" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  
                  <div class="find_from_w">
                  <span> {{ $t("logs.notify7") }}: </span> <el-input v-model=" dnoremail_from_b" placeholder=""></el-input>
                  </div>
                </div>
                  <div class="find1">
                 
                  <div class="find_from_w">
                   <span>{{ $t("logs.addt") }}:</span>   <el-date-picker
                v-model="creat_eamil_b"
                type="datetimerange"
                :range-separator="$t('wasteInsulate1.zhi')"
                :start-placeholder="$t('table.sdata')"
                :end-placeholder="$t('table.enddata')"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_from_b">{{
                  $t("confirm.search")
                }}</el-button>
                <el-button type="danger" @click="cancel_from_w()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_from_w"></div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList5"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                >
                </el-table-column>
                <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')">
                </el-table-column>
                  <el-table-column prop="CREATETIME" :label="$t('logs.addt')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template slot-scope="scope">
                    <!-- 删除-->

                    <el-button
                      @click="handleClick_black_from(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
                  <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums"
              ></el-pagination>
            </div>
            </div>
            <div class="pop-up" v-show="tanchu">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">保存</el-button>
                <el-button type="primary" @click="tanOff()">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 收信个性化 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.group3") }}</span>
          <div class="main">
            <p>
              <el-alert
                :title="this.load_hind7"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList6"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.group7_a1')"
                >
                </el-table-column>
                <el-table-column prop="POLICY" :label="$t('logs.policy7')">
                </el-table-column>
                <el-table-column prop="NOTE_TYPE" :label="$t('logs.policy12')">
                </el-table-column>
                <el-table-column prop="OBJ" :label="$t('logs.policy13')">
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.policy14')"
                  width="200"
                >
                  <template scope="scope">
                    <el-select
                      size="small"
                      v-model="scope.row.ACTION"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in actionn"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <span>{{ scope.row.date }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template slot-scope="scope">
                    <!-- 保存-->

                    <el-button
                      @click="handleClick_in(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.save") }}</el-button
                    >
                  </template></el-table-column
                >
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">保存</el-button>
                <el-button type="primary" @click="tanOff()">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 发信个性化 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.group4") }}</span>
          <div class="main">
            <p>
              <el-alert
                :title="this.load_hind8"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList7"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.group7_a1')"
                >
                </el-table-column>
                <el-table-column prop="POLICY" :label="$t('logs.policy7')">
                </el-table-column>
                <el-table-column prop="NOTE_TYPE" :label="$t('logs.policy12')">
                </el-table-column>
                <el-table-column prop="OBJ" :label="$t('logs.policy13')">
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.policy14')"
                  width="200"
                >
                  <template scope="scope">
                    <el-select
                      size="small"
                      v-model="scope.row.ACTION"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in actionn1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <span>{{ scope.row.date }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template slot-scope="scope">
                    <!-- 保存-->

                    <el-button
                      @click="handleClick_out(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.save") }}</el-button
                    >
                  </template></el-table-column
                >
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">保存</el-button>
                <el-button type="primary" @click="tanOff()">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 组成员设置 -->
      <el-tabs v-show="tanchu_sender_all" v-loading="loading">
        <!-- 策略组所属用户 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.group7_a3") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_sender_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>

              <el-button @click="save_sender_show()">{{
                $t("logs.ldap15")
              }}</el-button>
              <el-alert
                :title="this.show_hint"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_group_email"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                </el-table-column>
                <el-table-column
                  prop="USER_IN_GROUP"
                  :label="$t('logs.group7_a1')"
                >
                </el-table-column>
                <el-table-column prop="USERNAME" :label="$t('logs.autu5_a2')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_sender(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_sender" v-drag>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 域名或邮箱账号 -->
                    {{ $t("logs.notify7") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4 }"
                      placeholder="一行一个地址"
                      v-model="group_users"
                      style="margin:8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_sender">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_sender">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_sender"></div>
          </div>
        </el-tab-pane>
        <!-- 策略组所属部门-->
        <el-tab-pane label="" v-if="this.add_depapt == 1">
          <span slot="label"> {{ $t("logs.group7_a2") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_sender_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>

              <span class="main_text"> {{ $t("logs.group7_a4") }}:</span>

              <el-select
                v-model="domain_id"
                placeholder="请选择"
                filterable
                style="width:24%"
                @change="domain_id_select"
              >
                <el-option
                  v-for="item in domain_idd"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span class="main_text"> {{ $t("logs.group7_a5") }}:</span>

              <el-select
                v-model="depart_id"
                placeholder="请选择"
                style="width:26%"
                filterable
              >
                <el-option
                  v-for="item in depart_idd"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span class="main_text"> {{ $t("logs.group7_a6") }}:</span>
              <el-checkbox v-model="include_sub_depart"></el-checkbox>
              <el-button @click="save_depart()">{{
                $t("logs.Conditional7")
              }}</el-button>
            </p>
          </div>

          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_group_deport"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="DEPART_IN_GROUP"
                  :label="$t('logs.group7_a1')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="DEPART_IN_DOMAIN"
                  :label="$t('logs.group7_a7')"
                  width="160"
                >
                </el-table-column>
                <el-table-column
                  prop="ALLDEPARTNAME"
                  :label="$t('logs.group7_a5')"
                >
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="80"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_deport(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_sender" v-drag>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 域名或邮箱账号 -->
                    {{ $t("logs.notify7") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4 }"
                      placeholder="一行一个地址"
                      v-model="group_users"
                      style="margin:8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_sender">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_sender">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_sender"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 组规则设置 -->
      <el-tabs v-show="tanchu_rule_all" v-loading="loading">
        <!-- 组过滤规则 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.group7_bc1") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_rule_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>

              <el-button @click="save_rule_show()">{{
                $t("logs.group7_bc6")
              }}</el-button>
              <el-alert
                :title="this.show_hint1"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_group_regex"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="50"
                >
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                  width="200"
                >
                </el-table-column>
                <el-table-column prop="SHOWTYPE" :label="$t('table1.type')">
                </el-table-column>
                <el-table-column prop="HEADER_KEY" :label="$t('table1.header')">
                </el-table-column>
                <el-table-column
                  prop="SHOWDIRECT"
                  :label="$t('logs.firewall2_a2')"
                >
                </el-table-column>
                <el-table-column prop="SCORE" :label="$t('table1.score')">
                </el-table-column>
                <el-table-column prop="EMAIL_REGEX" :label="$t('table1.rule')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_group_regex(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_rule" v-drag="{ handle: '.pop_up_text_local_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain"><span class="span_pad"></span> {{$t('logs.group7_bc6')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 策略组名 -->
                    {{ $t("logs.userLevel2") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align:left;color:#0e2c5e">
                      {{ this.email_name }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 类型 -->
                    {{ $t("logs.smtpIp6") }}:
                  </div>
                  <div class="block block1">
                    <el-select
                      v-model="regex_type"
                      placeholder=""
                      @change="show_key"
                    >
                      <el-option
                        v-for="item in regex_type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 方向 -->
                    {{ $t("logs.Policy_list8") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="direct">
                      <el-radio :label="0">{{ $t("logs.group7_a9") }}</el-radio>
                      <el-radio :label="1">{{
                        $t("logs.firewall1_a2")
                      }}</el-radio>
                      <el-radio :label="2">{{
                        $t("logs.firewall1_a3")
                      }}</el-radio>
                      <el-radio :label="3">{{ $t("logs.group7_a8") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 分数 -->
                    {{ $t("logs.Content5") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="text"
                      placeholder="累计分数达到50，则邮件被拒收"
                      v-model="score"
                      style="margin:8px 0"
                    >
                    </el-input>
                  </div>
                </div>
                <div class="find1" v-if="this.header_key1 == 1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 表达式-->
                    {{ $t("logs.Policy_unit_regex4") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="text"
                      placeholder=""
                      v-model="header_key"
                      style="margin:8px 0"
                    >
                    </el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 表达式-->
                    {{ $t("logs.Regex_test2") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="text"
                      placeholder=""
                      v-model="filterregex"
                      style="margin:8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_rule" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_rule">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_rule"></div>
          </div>
        </el-tab-pane>
        <!-- 组IP白名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.group7_bc2") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_rule_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>

              <el-button @click="save_ipw_show()">{{
                $t("logs.group7_bc7")
              }}</el-button>
              <el-alert
                :title="this.show_hint2"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_group_ipw"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                >
                </el-table-column>

                <el-table-column prop="IP" :label="$t('logs.Policy_unit_ip1')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_group_ipw(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_ipw" v-drag="{ handle: '.pop_up_text_local_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain_edit"><span class="span_pad"></span> {{$t('logs.group7_bc7')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 策略组名 -->
                    {{ $t("logs.userLevel2") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align:left;color:#0e2c5e">
                      {{ this.email_name }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- ip -->
                    {{ $t("logs.Policy_unit_ip1") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="text"
                      placeholder=""
                      v-model="ipaddr"
                      style="margin:8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_ipw" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_ipw">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_ipw"></div>
          </div>
        </el-tab-pane>
        <!-- 组IP黑名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.group7_bc3") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_rule_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>

              <el-button @click="save_ipb_show()">{{
                $t("logs.group7_bc8")
              }}</el-button>
              <el-alert
                :title="this.show_hint3"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_group_ipb"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                >
                </el-table-column>

                <el-table-column prop="IP" :label="$t('logs.Policy_unit_ip1')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_group_ipb(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_ipb" v-drag="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.group7_bc8')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 策略组名 -->
                    {{ $t("logs.userLevel2") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align:left;color:#0e2c5e">
                      {{ this.email_name }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- ip -->
                    {{ $t("logs.Policy_unit_ip1") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="text"
                      placeholder=""
                      v-model="ipaddr"
                      style="margin:8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_ipb" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_ipb">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_ipb"></div>
          </div>
        </el-tab-pane>
        <!-- 组from白名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.group7_bc4") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_rule_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>

                        <el-button @click="daoru()" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.impws") }}</el-button>
                        <!-- 导出发件人白名单 -->

                        <el-button @click="daochu4()" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.expws") }}</el-button>
              <el-button @click="save_wl_show()">{{
                $t("logs.group7_bc9")
              }}</el-button>
              <el-alert
                :title="this.show_hint4"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
               <!-- 导入发件人白名单 -->
           <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_import_fromw' }"
            >
              <div class="pop_up_text  pop_up_text_import_fromw">
                <span style="padding:0 14px"></span>{{ $t("table1.impws") }}
              </div>
              <p></p>
                        <div class="find" v-loading="loading_from_user_white">
                            <div class="find1">
                                <!-- ip地址-->

                                <div class="find-text" style="padding-right:12px">

                                </div>
                                <div class="block block1">
                                    <input type="file" @change="inputFileChange" id="iupfile_fromw"  class="iupfile" ref="clearFile" accept=".txt" />
                                </div>
                            </div>

                        </div>
                        <el-row>
                            <el-button type="primary" size="mini" @click="save022_from_b">{{$t('tan.up')}}</el-button>
                            <el-button type="danger" @click="save24()">{{$t('tan.cancel')}}</el-button>
                        </el-row>

                    </div>
                    <div class="gray" v-show="tanchu"></div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_group_wl"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                >
                </el-table-column>

                <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_group_wl(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_wl" v-drag ="{ handle: '.pop_up_text_ipcor_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.group7_bc9')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 策略组名 -->
                    {{ $t("logs.userLevel2") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align:left;color:#0e2c5e">
                      {{ this.email_name }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- ip -->
                    {{ $t("logs.notify7") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="text"
                      placeholder=""
                      v-model="dnoremail"
                      style="margin:8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_wl" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_wl">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_wl"></div>
          </div>
        </el-tab-pane>
        <!-- 组from黑名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.group7_bc5") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_rule_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>
  <!-- 导入发件人黑名单 -->

                        <el-button @click="daoru()" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.impbs") }}</el-button>
                        <!-- 导出发件人黑名单 -->

                        <el-button @click="daochu5()" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.expbs") }}</el-button>
              <el-button @click="save_bl_show()">{{
                $t("logs.group7_bc10")
              }}</el-button>
              <el-alert
                :title="this.show_hint5"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
              <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_import_fromb' }"
            >
              <div class="pop_up_text  pop_up_text_import_fromb">
                <span style="padding:0 14px"></span>{{ $t("table1.impbs") }}
              </div>
              <p></p>
                        <div class="find" v-loading="loading_from_user_black">
                            <div class="find1">
                                <!-- ip地址-->

                                <div class="find-text" style="padding-right:12px">

                                </div>
                                <div class="block block1">
                                    <input type="file" @change="inputFileChange" id="iupfile_fromb" class="iupfile" ref="clearFile" accept=".txt" />
                                </div>
                            </div>

                        </div>
                        <el-row>
                            <el-button type="primary" size="mini" @click="save022_from_black">{{$t('tan.up')}}</el-button>
                            <el-button type="danger" @click="save24()">{{$t('tan.cancel')}}</el-button>
                        </el-row>

                    </div>
                    <div class="gray" v-show="tanchu"></div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_group_bl"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                </el-table-column>
                <el-table-column
                  prop="EMAIL_NAME"
                  :label="$t('logs.userLevel2')"
                >
                </el-table-column>

                <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_group_bl(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu_bl" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.group7_bc10')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 策略组名 -->
                    {{ $t("logs.userLevel2") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align:left;color:#0e2c5e">
                      {{ this.email_name }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- ip -->
                    {{ $t("logs.notify7") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="text"
                      placeholder=""
                      v-model="dnoremail"
                      style="margin:8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_bl" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_bl">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_bl"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 组收信个性化设置 -->

      <el-tabs
        v-show="tanchu_in_pol_all"
        v-loading="loading"
        @tab-click="dianji"
        v-model="activeName"
      >
        <!-- 发件人策略 -->
        <el-tab-pane label="" name="first">
          <span slot="label"> {{ $t("logs.policy1") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_envfrom_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>
              <span class="main_text"> {{ this.load_hind_pop }}</span>
              <el-input
                v-model="address_pop"
                style="width:20%;margin-right:10px"
                clearable
              ></el-input>
              <el-button @click="save_pop_table()">
                {{ $t("logs.policy6") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table" v-if="envfrom_policy == 0">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_group_pop"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="SHOW_KEY"
                  :label="$t('logs.policy7')"
                  width="200"
                >
                </el-table-column>
                <el-table-column prop="HINT" :label="$t('logs.policy8')">
                </el-table-column>
                <el-table-column
                  prop="DFT_VALUE"
                  :label="$t('logs.policy9')"
                  width="200"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 收件人策略 -->
        <el-tab-pane label="" name="second">
          <span slot="label"> {{ $t("logs.policy2") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_envfrom_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>
              <span class="main_text"> {{ this.load_hind_pop }}</span>
              <el-input
                v-model="address_pop"
                style="width:20%;margin-right:10px"
                clearable
              ></el-input>
              <el-button @click="save_pop_table()">
                {{ $t("logs.policy6") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table" v-if="envfrom_policy == 0">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_group_pop"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="SHOW_KEY"
                  :label="$t('logs.policy7')"
                  width="200"
                >
                </el-table-column>
                <el-table-column prop="HINT" :label="$t('logs.policy8')">
                </el-table-column>
                <el-table-column
                  prop="DFT_VALUE"
                  :label="$t('logs.policy9')"
                  width="200"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- IP策略 -->

        <el-tab-pane label="" name="third">
          <span slot="label"> {{ $t("logs.policy3") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_envfrom_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>
              <span class="main_text"> {{ this.load_hind_pop }}</span>
              <el-input
                v-model="address_pop"
                style="width:20%;margin-right:10px"
                clearable
              ></el-input>
              <el-button @click="save_pop_table()">
                {{ $t("logs.policy6") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table" v-if="envfrom_policy == 0">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_group_pop"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="SHOW_KEY"
                  :label="$t('logs.policy7')"
                  width="200"
                >
                </el-table-column>
                <el-table-column prop="HINT" :label="$t('logs.policy8')">
                </el-table-column>
                <el-table-column
                  prop="DFT_VALUE"
                  :label="$t('logs.policy9')"
                  width="200"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 已设置策略列表 -->
        <el-tab-pane label="" name="fourth">
          <span slot="label"> {{ $t("logs.policy4") }}</span>
          <div class="main">
            <p>
              <el-button @click="save_envfrom_hide()">{{
                $t("logs.Policy_back")
              }}</el-button>
            </p>
          </div>
          <div class="table">
            <el-table
              ref="multipleTable"
              tooltip-effect="dark"
              style="width: 100%"
              :data="fileList6"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                prop="RECSEQ"
                :label="$t('logs.xuhao')"
                width="60"
              >
              </el-table-column>
              <el-table-column prop="EMAIL_NAME" :label="$t('logs.group7_a1')">
              </el-table-column>
              <el-table-column prop="POLICY" :label="$t('logs.policy7')">
              </el-table-column>
              <el-table-column prop="NOTE_TYPE" :label="$t('logs.policy12')">
              </el-table-column>
              <el-table-column prop="OBJ" :label="$t('logs.policy13')">
              </el-table-column>
              <el-table-column
                prop="address"
                :label="$t('logs.policy14')"
                width="200"
              >
                <template scope="scope">
                  <el-select
                    size="small"
                    v-model="scope.row.ACTION"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in actionn"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <span>{{ scope.row.date }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" :label="$t('logs.audit6')">
                <template slot-scope="scope">
                  <!-- 保存-->

                  <el-button
                    @click="handleClick_in(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >{{ $t("table1.save") }}</el-button
                  >
                </template></el-table-column
              >
            </el-table>
            <div class="pop-up" v-show="tanchu">
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    策略用户:
                  </div>
                  <div class="block block1">
                    <el-input v-model="input" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend()">保存</el-button>
                <el-button type="primary" @click="tanOff()">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <div class="switch1" v-if="envfrom_policy == 1">
          <div class="table table_policy">
            <el-table
              ref="multipleTable"
              tooltip-effect="dark"
              style="width: 100%"
              :data="fileList_group_pop"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                prop="SHOW_KEY"
                :label="$t('logs.policy7')"
                width="160"
              >
              </el-table-column>
              <el-table-column prop="HINT" :label="$t('logs.policy8')">
              </el-table-column>
              <el-table-column
                prop="DFT_VALUE"
                :label="$t('logs.policy9')"
                width="110"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                :label="this.cfg_hint"
                width="160"
              >
                <template scope="scope">
                  <el-select
                    size="small"
                    v-model="scope.row.VALUE"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in q_action_type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                :label="$t('logs.audit6')"
                width="80"
              >
                <template slot-scope="scope">
                  <!--保存-->

                  <el-button
                    @click="save_group_list(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >{{ $t("table1.save") }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
       // 只可以选择今天之前的日期
      pickerOptions: {
        disabledDate(time) {
          var todayYear = new Date().getFullYear();
          var todayMonth = new Date().getMonth();
          var todayDay = new Date().getDate();
          var todayTime = new Date(
            todayYear,
            todayMonth,
            todayDay,
            "23",
            "59",
            "59"
          ).getTime(); // 毫秒

          return time.getTime() > todayTime;
        },
      },
      startdate:[],
      tanchu_from_w:false,
      domain_name1:'',
      salt_from_bl: 0,
      salt_from_bl_arr: [],
      salt_from_bl_show: 1,
      activeName: "first",
      pol_list_group_id: "",
      fileList_group_list: [],
      cfg_hint: "", //
      q_action_type: [],
      envfrom_policy: 0,
      // 组过滤规则
      regex_type: "SUBJECT",
      regex_type_arr: [],
      fileList_group_regex: [],
      fileList_group_ipw: [],
      fileList_group_ipb: [],
      fileList_group_wl: [],
      fileList_group_bl: [],
      tanchu_ipw: false,
      tanchu_ipb: false,
      tanchu_wl: false,
      tanchu_bl: false,
      dnoremail: "",
      header_key: "",
      header_key1: "",
      // 策略组所属部门
      add_depapt: "",
      domain_id: "",
      domain_idd: [],
      // 策略组所属用户
      depart_id: "",
      depart_idd: [],
      include_sub_depart: "",
      fileList_group_email: [],
      fileList_group_deport: [],
      action: 1,
      actionn: [],
      tanchu_group: false,
      group_name: "",
      cur_from: "",
      cur_to: "",
      cur_connect: "",
      ipaddr: "",
      filterregex: "",
      score: "",
      direct: "",
      direct_in: "",
      unit_type: "",
      unit_type1: [],
      unit_name_edit: "",
      group_users: "",

      show_hint: "",
      show_hint1: "",
      show_hint2: "",
      show_hint3: "",
      show_hint4: "",
      show_hint5: "",
      loading: false,
      tanchu_edit: false,
      tanchu_sender: false,
      tanchu_sender_all: false,
      tanchu_in_pol_all: false,
      tanchu_rule_all: false,
      tanchu_rule: false,
      fileList_group_pop: [],
      load_hind_pop: "",
      // tanchu_rul_all: true,

      filter_cell: true,
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",
      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      radio: [],
      load_hind1: "",
      load_hind2: "",
      load_hind3: "",
      load_hind4: "",
      load_hind5: "",
      load_hind6: "",
      load_hind7: "",
      load_hind8: "",
      group_id: "",
      address_pop: "",
      type_pop: "",
      email_name: "",
      dnoremail_from_w:"",
      dnoremail_from_b:"",
     email_name_from_w:"",
     email_name_from_b:"",
     creat_eamil:"",
     creat_eamil_b:"",
      // 总数
      totalnums: 0,
      size: 0,
      // 每页条数
      pagesize: 0,
      //   默认前往第几页
      page: 1,
      files:[],
      loading_from_user_white:false,
      loading_from_user_black:false,
      is_search:0,
    };
  },
  mounted() {
    this.getFileList();
    this.getFileList1();
    this.getFileList2();
    this.getFileList3();
    this.getFileList4();
    this.getFileList5();
    this.getFileList7();
    this.getFileList6();
  },
  methods: {
       // FORM黑名单导出
        daochu5() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_email_blsender";
            // console.log(__mode);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/aspam.cgi?__mode=${__mode}&email_name=${this.email_name}&sid=${sid}`);
        },
      // From黑名单增加 
        save022_from_black() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let iupfile = this.files;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
this.loading_from_user_black=true;

                let fd = new FormData();
                fd.append("iupfile", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", "upload_email_blsender");
                fd.append("sid", sid);
                   fd.append("email_name", this.email_name);
                // console.log(fd);
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/aspam.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                }).then((res) => {
                    // console.log(res);
                        this.loading_from_user_black = false;

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                        // this.getFileList2();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;


                        this.load_group_bl();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files = ''
                        // console.log(this.files)

                        this.$message({
                            type: "success",
                            message: `${res.data.ret}`,
                        });
                        // this.$message({
                        //     type: "success",
                        //     message: `${this.$t('anti_gs1_tan.del3')}`,
                        // });
                    }
                    // this.getFileList2();
                });
            }
        },
        // From白名单增加
        save022_from_b() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let iupfile = this.files;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
this.loading_from_user_white=true;

                let fd = new FormData();
                fd.append("iupfile", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", "upload_email_wlsender");
                fd.append("sid", sid);
                fd.append("email_name", this.email_name);
                // console.log(fd);
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/aspam.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                }).then((res) => {
                    console.log(res);
                        this.loading_from_user_white = false;

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                        // this.getFileList2();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;


                        this.load_group_wl();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files = ''
                        // console.log(this.files)

                        this.$message({
                            type: "success",
                            message: `${res.data.ret}`,
                        });
                        // this.$message({
                        //     type: "success",
                        //     message: `${this.$t('anti_gs1_tan.del3')}`,
                        // });
                    }
                    // this.getFileList2();
                });
            }
        },
     inputFileChange(e) {
           
            this.files = e.target.files[0];
            // console.log(this.files,'fangwei');
        },
          save24() {
            this.tanchu = false;
        },
             // 外层FORM黑名单导出
        daochu_wrap_b() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_allemail_sender";
            // console.log(__mode);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/aspam.cgi?__mode=${__mode}&is_white=0}&is_user=${this.salt_from_bl}&email_name=${this.email_name}&sid=${sid}`);
        },
          // 外层FORM白名单导出
        daochu_wrap_w() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_allemail_sender";
            // console.log(__mode);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/aspam.cgi?__mode=${__mode}&is_white=1}&is_user=${this.salt_from_bl}&email_name=${this.email_name}&sid=${sid}`);
        },
      // FORM白名单导出
        daochu4() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_email_wlsender";
            // console.log(__mode);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/aspam.cgi?__mode=${__mode}&email_name=${this.email_name}&sid=${sid}`);
        },
     // ip白名单 导入
        daoru() {
            // console.log('aa')
            this.tanchu = true;
            this.$refs.clearFile.value = '';
      
         document.getElementById("iupfile_fromw").value=""
        //  document.getElementById("iupfile_fromb").value=""
        //  document.getElementById("iupfile_recip").value=""
        //  document.getElementById("iupfile_forge").value=""
         
       
            // this.files = ''
            // this.files_ipb = ''
     

       
        },
     // 每页显示多少条 -- 切换
    handleSizeChange(val) {
   
      this.pagesize = val;

  

      this.getFileList4();
    },
    // 当前第几页
    handleCurrentChange(val) {
     
      this.page = val;

      this.getFileList4();
    },
     // 增加from 黑名单
      save_from_b() {
      this.getFileList5()
     
    },
    // 增加from 白名单
      save_from_w() {
        this.is_search=1
    this.tanchu_from_w=false
    console.log(this.s_createtime)
      this.getFileList4()
     
    },
    cancel_from_w(){
      this.tanchu_from_w=false

    },
    tan_white(){
      this.tanchu_from_w=true
        this.dnoremail_from_w=''
     this.email_name_from_w=''
    this.creat_eamil=''
    },
    dianji(a) {
      console.log(a.index);
      this.address_pop = "";
      if (a.index == 0) {
        this.type_pop = "from";
        this.load_group_pol_from();
      } else if (a.index == 1) {
        this.type_pop = "to";
        this.load_group_pol_from();
      } else if (a.index == 2) {
        this.type_pop = "connect";
        this.load_group_pol_from();
      } else if (a.index == 3 && this.direct_in == "in") {
        this.getFileList6();
      } else if (a.index == 3 && this.direct_in == "out") {
        this.getFileList7();
      }
    },
    // 组发信个性化设置
    save_pop_table() {
      this.load_group_pol_from();
    },
    show_key(a) {
      // console.log(a)
      if (a == "HEADERS") {
        this.header_key1 = 1;
      } else {
        this.header_key1 = 0;
      }
    },
    domain_id_select(domain) {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let domain_id = domain;
      let str = this.$qs.stringify({
        __mode: "load_domain_depart",
        sid: sid,
        domain_id: domain_id,
      });

      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.depart_idd = res.data.ret.q_depart;
          // depart_id
          // this.getFileList7()
          // this.$message({
          //     type: "success",
          //     message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
          // });
        }
      });
    },
    //组收信个性化设置
    bianji3(index, scope) {
      console.log(index, scope);
      this.email_name = scope.EMAIL_ID;
      // console.log(this.group_name)
      this.tanchu_in_pol_all = true;
      this.filter_cell = false;
      this.direct_in = "in";
      this.type_pop = "from";
      this.load_group_pol_from();
      // this.dianji()
      this.activeName = "first";
    },
    // 组发信个性化设置
    bianji4(index, scope) {
      console.log(index, scope);
      this.email_name = scope.EMAIL_ID;
      // console.log(this.group_name)
      this.tanchu_in_pol_all = true;
      this.filter_cell = false;
      this.direct_in = "out";
      this.type_pop = "from";
      this.load_group_pol_from();
      this.activeName = "first";

      // this.dianji()
    },
    //组规则
    bianji2(index, scope) {
      console.log(index, scope);
      this.email_name = scope.EMAIL_NAME;
      // console.log(this.group_name)
      this.tanchu_rule_all = true;
      this.filter_cell = false;
      this.load_group_regex();
      this.load_group_ipw();
      this.load_group_ipb();
      this.load_group_wl();
      this.load_group_bl();
      this.getFileList_group_depart();
    },
    //组成员
    bianji1(index, scope) {
      // console.log(index, scope)
      this.group_name = scope.GROUP_NAME;
      // console.log(this.group_name)
      this.tanchu_sender_all = true;
      this.filter_cell = false;
      this.getFileList_group_email();
      this.getFileList_group_depart();
    },
    //  删除
    handleClick_out(index, scope) {
      // console.log(index, scope)

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let email_name = scope.EMAIL_ID;
      let address = scope.OBJ;
      let policy = scope.POLICY1;
      let direct = scope.DIRECT;
      let type = scope.TYPE;
      let chkaction = scope.ACTION;

      let str = this.$qs.stringify({
        __mode: "save_email_policy",
        sid: sid,
        email_id: email_name,
        address: address,
        policy: policy,
        direct: direct,
        type: type,
        chkaction: chkaction,
      });

      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList7();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 加载
    getFileList7() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_email_pol_list",
            sid: sid,
            direct: "out",
            email_name: this.email_name,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList7 = res.data.ret.datalist;
            if (this.email_name != "") {
              this.fileList6 = res.data.ret.datalist;
            }
            //
            this.load_hind8 = res.data.ret.LOAD_HINT;
            this.actionn1 = res.data.ret.q_action;

            // 总条数

            this.loading = false;
          }
        });
    },
    //  删除
    handleClick_in(index, scope) {
      console.log(index, scope);

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let email_name = scope.EMAIL_ID;
      let address = scope.OBJ;
      let policy = scope.POLICY1;
      let direct = scope.DIRECT;
      let type = scope.TYPE;
      let chkaction = scope.ACTION;

      let str = this.$qs.stringify({
        __mode: "save_email_policy",
        sid: sid,
        email_id: email_name,
        address: address,
        policy: policy,
        direct: direct,
        type: type,
        chkaction: chkaction,
      });

      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList6();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 加载
    getFileList6() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_email_pol_list",
            sid: sid,
            direct: "in",
            email_name: this.email_name,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList6 = res.data.ret.datalist;
            this.load_hind7 = res.data.ret.LOAD_HINT;
            this.actionn = res.data.ret.q_action;
            // this.action = res.data.ret.ACTION;

            // 总条数

            this.loading = false;
          }
        });
    },
    //  删除
    handleClick_black_from(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let dnoremail = scope.DNOREMAIL;
          let fk_email_pol_id = scope.EMAIL_ID;

          let str = this.$qs.stringify({
            __mode: "del_email_blsender",
            sid: sid,
            dnoremail: dnoremail,
            fk_email_pol_id: fk_email_pol_id,
          });
          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList5();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },

    // 加载
    getFileList5() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_email_allblsender",
            sid: sid,
  s_dnoremail:this.dnoremail_from_b,
     s_emailname:this.email_name_from_b,
     s_createtime:this.creat_eamil_b,
       size:this.size,
     page:this.page,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList5 = res.data.ret.datalist;
            this.load_hind6 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    //  删除
    handleClick_from(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let dnoremail = scope.DNOREMAIL;
          let fk_email_pol_id = scope.EMAIL_ID;

          let str = this.$qs.stringify({
            __mode: "del_email_wlsender",
            sid: sid,
            dnoremail: dnoremail,
            fk_email_pol_id: fk_email_pol_id,
            type: this.salt_from_bl,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList4();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    change1(a) {
      console.log(a);
  this.getFileList4()
    
    },
     search_domian() {
        // this.loading = false;
            this.getFileList4()
        },
    // 加载
    getFileList4() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_email_allwlsender",
            sid: sid,
type: this.salt_from_bl,

  s_dnoremail:this.dnoremail_from_w,
     s_emailname:this.email_name_from_w,
    s_createtime:  this.creat_eamil==''? '':JSON.stringify(this.creat_eamil) ,
     size:this.size,
     page:this.page,
     is_search:this.is_search
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu_from_w=false

            this.fileList4 = res.data.ret.datalist;
            this.load_hind5 = res.data.ret.LOAD_HINT;
            this.salt_from_bl_arr = res.data.ret.q_type;
             // 总条数
            this.totalnums = res.data.ret.totalnums;
            this.size = res.data.ret.pagesize;
            this.page = res.data.ret.page;
            this.dnoremail_from_w = res.data.ret.s_dnoremail;
            this.email_name_from_w = res.data.ret.s_emailname;
            this.creat_eamil = res.data.ret.s_createtime;
            this.is_search = res.data.ret.is_search;
           
this.$nextTick(() => {
              this.$refs.multipleTable4.bodyWrapper.scrollTop = 0;
            });
            this.loading = false;
          }
        });
    },
    //  删除
    handleClick_black(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let ipaddr = scope.ORGIP;
          let fk_email_pol_id = scope.EMAIL_ID;

          let str = this.$qs.stringify({
            __mode: "del_email_ipbl",
            sid: sid,
            ipaddr: ipaddr,
            fk_email_pol_id: fk_email_pol_id,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList3();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 加载
    getFileList3() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_email_ipbl",
            sid: sid,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList3 = res.data.ret.datalist;
            this.load_hind4 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    //  删除
    handleClick_white(index, scope) {
      console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let ipaddr = scope.ORGIP;
          let fk_email_pol_id = scope.EMAIL_ID;

          let str = this.$qs.stringify({
            __mode: "del_email_ipwl",
            sid: sid,
            ipaddr: ipaddr,
            fk_email_pol_id: fk_email_pol_id,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList2();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 加载
    getFileList2() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_email_ipwl",
            sid: sid,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList2 = res.data.ret.datalist;
            this.load_hind3 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    //  删除
    handleClick_regex(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let rule_id = scope.RULE_ID;

          let str = this.$qs.stringify({
            __mode: "del_email_regex",
            sid: sid,
            rule_id: rule_id,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList1();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_email_regex",
            sid: sid,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList1 = res.data.ret.datalist;
            this.load_hind2 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    //  删除
    handleClick_group(index, scope) {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let email_name = scope.EMAIL_NAME;

      let str = this.$qs.stringify({
        __mode: "del_email_name",
        sid: sid,
        email_name: email_name,
      });

      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.del1")}`,
          });
        }
      });
    },
    // 编辑
    save_group() {
      // this.loading = true;
this.$save_hint_test();
this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_email_name",
        sid: sid,
        email_name: this.email_name,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu_group = false;
          this.getFileList();
          // 总条数
        }
      });
    },
    // 加载
    getFileList() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: " load_email_name",
            sid: sid,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList = res.data.ret.datalist;
            this.load_hind1 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    // 显示
    tan: function() {
      this.tanchu_group = true;
      this.email_name = "";
    },
    cancel_group: function() {
      this.tanchu_group = false;
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
    },
    tanOff: function() {
      this.tanchu = false;
    },
    off_sender() {
      this.tanchu_sender = false;
    },
    off_rule() {
      this.tanchu_rule = false;
    },
    off_ipw() {
      this.tanchu_ipw = false;
    },
    off_ipb() {
      this.tanchu_ipb = false;
    },
    off_wl() {
      this.tanchu_wl = false;
    },
    off_bl() {
      this.tanchu_bl = false;
    },
    // 返回
    save_envfrom_hide() {
      this.tanchu_in_pol_all = false;
      this.filter_cell = true;
    },
    // 返回
    save_sender_hide() {
      this.tanchu_sender_all = false;
      this.filter_cell = true;
    },
    // 返回
    save_rule_hide() {
      this.tanchu_rule_all = false;
      this.filter_cell = true;
    },
    // 组成员设置显示隐藏
    save_sender_show() {
      this.tanchu_sender = true;
    },
    // 组IP黑名单编辑
    save_wl_show() {
      this.tanchu_wl = true;
      this.dnoremail = "";
    },
    save_bl_show() {
      this.tanchu_bl = true;
      this.dnoremail = "";
    },
    // 组IP黑名单编辑
    save_ipb_show() {
      this.tanchu_ipb = true;
      this.ipaddr = "";
    },
    // 组IP白名单编辑
    save_ipw_show() {
      this.tanchu_ipw = true;
      this.ipaddr = "";
      // this.header_key = ''
      // this.regex_type = 'SUBJECT'
      // this.direct = 0
      // this.show_key()
    },
    // 组规则编辑
    save_rule_show() {
      this.tanchu_rule = true;
      this.filterregex = "";
      this.header_key = "";
      this.regex_type = "SUBJECT";
      this.direct = 0;
      this.show_key();
    },
    // 组规则设置保存
    save_rule() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_email_regex",
        sid: sid,
        email_name: this.email_name,
        type: this.regex_type,
        direct: this.direct,
        score: this.score,
        header_key: this.header_key,
        filterregex: this.filterregex,
      });
      // console.log(this.filterregex)
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
         
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
         
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_rule = false;
          this.loading = false;
          this.load_group_regex();
        }
      });
    },
    // 加载
    getFileList_group_email() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_group_user",
            sid: sid,
            group_name: this.group_name,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.add_depapt = res.data.ret.ADD_DEPART_ON;
            // console.log(this.add_depapt, 'this.add_depapt')
            this.fileList_group_email = res.data.ret.datalist;
            // this.load_hind1 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    // 策略组所属部门编辑保存
    save_depart() {
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_group_depart",
        sid: sid,
        group_name: this.group_name,
        domain_id: this.domain_id,
        depart_id: this.depart_id,
        include_sub_depart: this.include_sub_depart == true ? 1 : 0,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
         
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          // this.tanchu = false
          // this.tanchu_sender = false
          this.loading = false;
          this.getFileList_group_depart();
        }
      });
    },
    // 组成员设置编辑保存
    save_sender() {
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_group_bulk_user",
        sid: sid,
        group_name: this.group_name,
        group_users: this.group_users,
        type: 1,
        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_sender = false;
          this.loading = false;
          this.getFileList_group_email();
        }
      });
    },
    // 组成员设置 删除
    handleClick_sender(index, scope) {
      // console.log(index, scope)
      this.$confirm("确定要删除吗", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let fk_grp_pol_id = scope.GROUP_ID;
          let username = scope.USERNAME;
          let type = scope.TYPE;
          let str = this.$qs.stringify({
            __mode: "del_group_user",
            sid: sid,
            fk_grp_pol_id: fk_grp_pol_id,
            username: username,
            type: type,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList_group_email();
              this.$message({
                type: "success",
                message: "删除成功",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 策略组所属部门加载
    getFileList_group_depart() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_group_depart",
            sid: sid,
            group_name: this.group_name,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.add_depapt = res.data.ret.ADD_DEPART_ON;
            this.fileList_group_deport = res.data.ret.datalist;
            this.domain_idd = res.data.ret.q_domain;
            // this.load_hind1 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },

    // 组成员设置 删除
    handleClick_deport(index, scope) {
      // console.log(index, scope)
      this.$confirm("确定要删除吗", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let fk_grp_pol_id = scope.GROUP_ID;
          let depart_id = scope.DEPART_ID;
          let type = scope.TYPE;
          let str = this.$qs.stringify({
            __mode: "del_group_depart",
            sid: sid,
            fk_grp_pol_id: fk_grp_pol_id,
            depart_id: depart_id,
            type: type,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList_group_depart();
              this.$message({
                type: "success",
                message: "删除成功",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 组过滤规则加载
    load_group_regex() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_email_regex",
            sid: sid,
            email_name: this.email_name,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList_group_regex = res.data.ret.datalist;
            this.regex_type_arr = res.data.ret.q_regex_type;
            this.score = res.data.ret.score;

            this.show_hint1 = res.data.ret.LOAD_HINT;
            // this.load_hind1 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    // 组过滤规则删除
    handleClick_group_regex(index, scope) {
      console.log(index, scope);
      this.$confirm("确定要删除吗", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let rule_id = scope.RULE_ID;

          let str = this.$qs.stringify({
            __mode: "del_email_regex",
            sid: sid,
            rule_id: rule_id,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.load_group_regex();
              this.$message({
                type: "success",
                message: "删除成功",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 组IP白名单加载
    load_group_ipw() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_email_ipwl",
            sid: sid,
            email_name: this.email_name,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList_group_ipw = res.data.ret.datalist;
            // this.regex_type_arr = res.data.ret.q_regex_type;
            // this.score = res.data.ret.score;

            this.show_hint2 = res.data.ret.LOAD_HINT;
            // this.load_hind1 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    // 组IP白名单删除
    handleClick_group_ipw(index, scope) {
      console.log(index, scope);
      this.$confirm("确定要删除吗", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let ipaddr = scope.ORGIP;
          let fk_email_pol_id = scope.EMAIL_ID;

          let str = this.$qs.stringify({
            __mode: "del_email_ipwl",
            sid: sid,
            ipaddr: ipaddr,
            fk_email_pol_id: fk_email_pol_id,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.load_group_ipw();
              this.$message({
                type: "success",
                message: "删除成功",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //  组IP白名单 编辑保存
    save_ipw() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_email_ipwl",
        sid: sid,
        email_name: this.email_name,
        ipaddr: this.ipaddr,
      });
      // console.log(this.filterregex)
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
         
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
         
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_ipw = false;
          this.loading = false;
          this.load_group_ipw();
        }
      });
    },
    // 组IP黑名单加载
    load_group_ipb() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_email_ipbl",
            sid: sid,
            email_name: this.email_name,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList_group_ipb = res.data.ret.datalist;
            // this.regex_type_arr = res.data.ret.q_regex_type;
            // this.score = res.data.ret.score;

            this.show_hint3 = res.data.ret.LOAD_HINT;
            // this.load_hind1 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    // 组IP黑名单删除
    handleClick_group_ipb(index, scope) {
      // console.log(index, scope)
      this.$confirm("确定要删除吗", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let ipaddr = scope.ORGIP;
          let fk_email_pol_id = scope.EMAIL_ID;

          let str = this.$qs.stringify({
            __mode: "del_email_ipbl",
            sid: sid,
            ipaddr: ipaddr,
            fk_email_pol_id: fk_email_pol_id,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.load_group_ipb();
              this.$message({
                type: "success",
                message: "删除成功",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //  组IP黑名单 编辑保存
    save_ipb() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_email_ipbl",
        sid: sid,
        email_name: this.email_name,
        ipaddr: this.ipaddr,
      });
      // console.log(this.filterregex)
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
         
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
         
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_ipb = false;
          this.loading = false;
          this.load_group_ipb();
        }
      });
    },
    // 组from白名单加载
    load_group_wl() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_email_allwlsender",
            sid: sid,
            email_name: this.email_name,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList_group_wl = res.data.ret.datalist;
            // this.regex_type_arr = res.data.ret.q_regex_type;
            // this.score = res.data.ret.score;

            this.show_hint4 = res.data.ret.LOAD_HINT;
            // this.load_hind1 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    // 组from白名单删除
    handleClick_group_wl(index, scope) {
      // console.log(index, scope)
      this.$confirm("确定要删除吗", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let dnoremail = scope.DNOREMAIL;
          let fk_email_pol_id = scope.EMAIL_ID;

          let str = this.$qs.stringify({
            __mode: "del_email_wlsender",
            sid: sid,
            dnoremail: dnoremail,
            fk_email_pol_id: fk_email_pol_id,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.load_group_wl();
              this.$message({
                type: "success",
                message: "删除成功",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //  组from白名单编辑保存
    save_wl() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_email_wlsender",
        sid: sid,
        email_name: this.email_name,
        dnoremail: this.dnoremail,
      });
      // console.log(this.filterregex)
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
         
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_wl = false;
          this.loading = false;
          this.load_group_wl();
        }
      });
    },
    // 组from白名单加载
    load_group_bl() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_email_allblsender",
            sid: sid,
            email_name: this.email_name,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          // console.log(res)
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList_group_bl = res.data.ret.datalist;
            // this.regex_type_arr = res.data.ret.q_regex_type;
            // this.score = res.data.ret.score;

            this.show_hint5 = res.data.ret.LOAD_HINT;
            // this.load_hind1 = res.data.ret.LOAD_HINT;
            // 总条数

            this.loading = false;
          }
        });
    },
    // 组from白名单删除
    handleClick_group_bl(index, scope) {
      // console.log(index, scope)
      this.$confirm("确定要删除吗", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let dnoremail = scope.DNOREMAIL;
          let fk_email_pol_id = scope.EMAIL_ID;

          let str = this.$qs.stringify({
            __mode: "del_email_blsender",
            sid: sid,
            dnoremail: dnoremail,
            fk_email_pol_id: fk_email_pol_id,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.load_group_bl();
              this.$message({
                type: "success",
                message: "删除成功",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //  组from黑名单编辑保存
    save_bl() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_email_blsender",
        sid: sid,
        email_name: this.email_name,
        dnoremail: this.dnoremail,
      });
      // console.log(this.filterregex)
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
         
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
         
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_bl = false;
          this.loading = false;
          this.load_group_bl();
        }
      });
    },
    //
    // 发件人策略加载
    load_group_pol_from() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_email_pol_lization",
            sid: sid,
            email_id: this.email_name,
            direct: this.direct_in,
            address: this.address_pop,
            type: this.type_pop,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.load_hind_pop = res.data.ret.LOAD_HINT;
            this.fileList_group_pop = res.data.ret.datalist;
            this.q_action_type = res.data.ret.q_action_type;
            this.envfrom_policy = res.data.ret.SHOW_CFG;
            this.show_hint5 = res.data.ret.LOAD_HINT;
            this.cfg_hint = res.data.ret.CFG_HINT;

            this.loading = false;
          }
        });
    },
    // 设置对象当前策略保存
    save_group_list(index, row) {
      console.log(index, row);
      // this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_email_policy",
        sid: sid,
        email_id: this.email_name,
        direct: this.direct_in,
        address: this.address_pop,
        type: this.type_pop,
        chkaction: row.VALUE,
        policy: row.KEY,
      });
      console.log(str);
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.loading = false;
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.loading = false;
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          // this.loading = false;
          this.load_group_pol_from();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    //
  },
};
</script>

<style lang="less" scoped>
.table_policy {
  /deep/ .has-gutter th:nth-child(3) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(3) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(5) {
    text-align: center;
  }
}

// 1
.main {
  display: flex;

  align-items: center;
  border: 2px solid #d2d7e6;
  // background: #f1f1f1;
  margin: 0px;

  text-align: left;
  //   margin-top: 20px;
}

.main p {
  height: 44px;
  width: 100%;
  display: flex;
  padding-left: 10px;
  font-size: 12px;

  align-items: center;
  // line-height: 28px;
}

.main_text {
  margin-right: 6px;
  margin-left: 6px;
  color: #0e2c5e;
}

.main .main_input {
  margin-right: 6px;
  width: 20%;
}

.main .el-select {
  margin-right: 6px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/fengye.less";
@import "../../css/drag.less";

.fenye{
  margin :0px;
}
.find_from_w{
  width: 100%;
  span{
    text-align: right;
    width: 30%;
    margin-right:10px
  }
  .el-input{
    width: 65%;
  }
  .el-date-editor .el-range-separator{
    padding: 0 3px;
    line-height: 30px;
      }
  .el-input__inner{
    padding: 0 1px;
  }
  .el-date-editor--datetimerange.el-input__inner{
     width: 65%;
  }
 /deep/ .el-date-editor .el-range-input{
    font-size: 13px;
  }
     display: flex;
      align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #0E2C5E;
    

}
.pop-up .el-radio {
  margin-right: 4px;
}
.pop-up .pop_up_text_ROUTE_ADDRESS,.pop-up .pop_up_text_ROUTE_ADDRESS_edit {
  width: 100%;
}
.pop_up_text_ROUTE_ADDRESS,.pop_up_text_ROUTE_ADDRESS_edit {
  background: #eee;
}
</style>
